import C from './constants'

export const setDensityCorrection = (values) => (
    {
        type: C.SET_DENSITY_CORRECTION_VALUES,
        payload: values 
    }
)
